<div class="episode-recurrence-options">
  <!-- Recurrence start date -->
  <div class="row">
    <div class="col-lg-6">
      <mat-form-field appearance="fill" (click)="episodeStartDatePicker.open()">
        <mat-label>Start date</mat-label>
        <input
          matInput
          [matDatepicker]="episodeStartDatePicker"
          [min]="minDate"
          [readonly]="true"
          [formControl]="recurrenceForm.controls.startDate"
          data-testId="epg-episode-recurrence-start-date"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="episodeStartDatePicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #episodeStartDatePicker></mat-datepicker>
        <mat-error
          *ngIf="recurrenceForm.controls.startDate.errors?.['required']"
          data-testId="epg-episode-recurrence-start-date-error"
        >
          Start date is required
        </mat-error>
        <mat-error
          *ngIf="recurrenceForm.controls.startDate.errors?.['matDatepickerMin']"
          data-testId="epg-episode-recurrence-start-date-error"
        >
          Start date must be after today
        </mat-error>
      </mat-form-field>
    </div>
  </div>

  <!-- Recurrence type settings -->
  <div class="row">
    <div class="col-lg-6">
      <mat-form-field appearance="fill">
        <mat-label>Each</mat-label>
        <input
          matInput
          type="number"
          placeholder="Recurrence number"
          [min]="1"
          [max]="99"
          [formControl]="recurrenceForm.controls.repeatNumber"
          data-testId="epg-episode-recurrence-number-input"
        />
        <mat-error
          *ngIf="recurrenceForm.controls.repeatNumber.errors?.['required']"
          data-testId="epg-episode-recurrence-number-input-error"
        >
          This field is <strong>required</strong>
        </mat-error>
        <mat-error
          *ngIf="recurrenceForm.controls.repeatNumber.errors?.['min'] ||
          recurrenceForm.controls.repeatNumber.errors?.['max']"
          data-testId="epg-episode-recurrence-number-input-error"
        >
          Number must be between 1 and 99
        </mat-error>
        <mat-error
          *ngIf="recurrenceForm.controls.repeatNumber.errors?.['integer']"
          data-testId="epg-episode-recurrence-number-input-error"
        >
          Only integer values are allowed
        </mat-error>
      </mat-form-field>
    </div>
    <div class="col-lg-6">
      <mat-form-field appearance="fill">
        <mat-label>Recurrence</mat-label>
        <mat-select
          placeholder="Recurrence type"
          [value]="data.schedule.recurrence.type"
          (selectionChange)="onChangeRecurrenceType($event)"
          data-testId="epg-episode-recurrence-type-dropdown"
        >
          <ng-container *ngFor="let recurrenceType of recurrenceTypeOptions">
            <mat-option
              [value]="recurrenceType.value"
              data-testId="epg-episode-recurrence-type-option"
            >
              {{ recurrenceType.label }}
            </mat-option>
          </ng-container>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <!-- Weekly recurrence settings -->
  <div
    *ngIf="data.schedule.recurrence.type === RecurrenceType.Week"
    class="row"
  >
    <div class="day-selector">
      <button
        mat-raised-button
        *ngFor="let day of daysOfWeek"
        [class.selected]="day.selected"
        (click)="toggleDay(day)"
        data-testId="epg-weekly-recurrence-day-selector"
      >
        {{ day.label }}
      </button>
    </div>
  </div>

  <!-- Monthly recurrence settings -->
  <div
    *ngIf="data.schedule.recurrence.type === RecurrenceType.Month"
    class="row"
  >
    <div class="col-lg-6">
      <mat-radio-group
        [(ngModel)]="data.schedule.recurrence.recurrence.type"
        (change)="monthlyRecurrenceTypeChange($event)"
        aria-label="Select an option"
      >
        <div class="monthly-recurrence-option">
          <div class="radio-button-wrapper">
            <mat-radio-button
              [value]="MonthRecurrenceType.Day"
              data-testId="epg-monthly-recurrence-day-type-button"
            >
              On day
            </mat-radio-button>
          </div>
          <mat-form-field appearance="fill">
            <mat-label>Month day</mat-label>
            <input
              matInput
              type="number"
              placeholder="Month day"
              [min]="1"
              [max]="31"
              [formControl]="selectedMonthDay"
              data-testId="epg-monthly-recurrence-day-type-input"
            />
            <mat-error
              *ngIf="selectedMonthDay.errors?.['required']"
              data-testId="epg-monthly-recurrence-day-type-input-error"
            >
              This field is <strong>required</strong>
            </mat-error>
            <mat-error
              *ngIf="selectedMonthDay.errors?.['min'] || selectedMonthDay.errors?.['max']"
              data-testId="epg-monthly-recurrence-day-type-input-error"
            >
              Month day must be between 1 and 31
            </mat-error>
            <mat-error
              *ngIf="selectedMonthDay.errors?.['integer']"
              data-testId="epg-monthly-recurrence-day-type-input-error"
            >
              Only integer values are allowed
            </mat-error>
          </mat-form-field>
        </div>
        <div class="monthly-recurrence-option">
          <div class="radio-button-wrapper">
            <mat-radio-button
              [value]="MonthRecurrenceType.WeekDay"
              data-testId="epg-monthly-recurrence-weekday-type-button"
            >
              On the
            </mat-radio-button>
          </div>
          <mat-form-field class="ordinal-input" appearance="fill">
            <mat-label>Ordinal</mat-label>
            <mat-select
              placeholder="Ordinal"
              [(ngModel)]="selectedOrdinal"
              [disabled]="
                data.schedule.recurrence.recurrence.type !==
                MonthRecurrenceType.WeekDay
              "
              (selectionChange)="onRecurrenceWeekDayChange()"
              data-testId="epg-monthly-recurrence-weekday-type-ordinal-dropdown"
            >
              <ng-container *ngFor="let ordinal of ordinalOptions">
                <mat-option
                  [value]="ordinal.value"
                  data-testId="epg-monthly-recurrence-weekday-type-ordinal-option"
                >
                  {{ ordinal.label }}
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Week day</mat-label>
            <mat-select
              placeholder="Week day"
              [(ngModel)]="selectedWeekDay"
              [disabled]="
                data.schedule.recurrence.recurrence.type !==
                MonthRecurrenceType.WeekDay
              "
              (selectionChange)="onRecurrenceWeekDayChange()"
              data-testId="epg-monthly-recurrence-weekday-type-weekday-dropdown"
            >
              <ng-container *ngFor="let weekday of weekDaysOptions">
                <mat-option
                  [value]="weekday.value"
                  data-testId="epg-monthly-recurrence-weekday-type-weekday-option"
                >
                  {{ weekday.label }}
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
        </div>
      </mat-radio-group>
    </div>
  </div>

  <!-- Recurrence end date -->
  <div class="row">
    <div class="col-lg-6">
      <mat-form-field appearance="fill" (click)="episodeEndDatePicker.open()">
        <mat-label>End date</mat-label>
        <input
          matInput
          [matDatepicker]="episodeEndDatePicker"
          [min]="data.startDate"
          [readonly]="true"
          [formControl]="recurrenceForm.controls.endDate"
          data-testId="epg-episode-recurrence-end-date"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="episodeEndDatePicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #episodeEndDatePicker></mat-datepicker>
        <mat-error
          *ngIf="recurrenceForm.controls.endDate.errors?.['required']"
          data-testId="epg-episode-recurrence-end-date-error"
        >
          End date is required
        </mat-error>
        <mat-error
          *ngIf="recurrenceForm.controls.endDate.errors?.['matDatepickerMin']"
          data-testId="epg-episode-recurrence-end-date-error"
        >
          End date must be after start date
        </mat-error>
      </mat-form-field>
    </div>
    <div class="col-lg-6">
      <mat-checkbox
        class="repeat-indefinitely-checkbox"
        [(ngModel)]="repeatsIndefinitely"
        (change)="onRepeatsIndefinitelyChange()"
        data-testId="epg-episode-recurrence-repeat-indefinitely-checkbox"
      >
        <span>Repeats indefinitely</span>
      </mat-checkbox>
    </div>
  </div>

  <div class="row" *ngIf="recurrenceSettingsError !== null">
    <div class="col-lg-12">
      {{ recurrenceSettingsError }}
    </div>
  </div>

  <!-- Human readable recurrence settings -->
  <div class="row">
    <div
      class="col-lg-12"
      data-testId="epg-episode-recurrence-settings-message"
    >
      {{ recurrenceSettingsMessage }}
    </div>
  </div>
</div>
